<template>
  <div>
    <span
      style="
        font-weight: bold;
        font: 700 30px/34px 'Microsoft YaHei';
        display: block;
        color: #000;
        overflow: hidden;
        width: 600px;
        text-overflow: ellipsis;
        margin-left: auto;
        margin-right: auto;
        border-color: #ccc;
        border-bottom-style: solid;
        border-width: 1px;
        padding-bottom: 10px;
        margin-bottom: 10px;
      "
      >{{ detail.title }}</span
    >
    <div
      style="
        font-size: 16px;
        display: block;
        color: #000;
        overflow: hidden;
        width: 600px;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-left: auto;
        margin-right: auto;
      "
    >
      <a style="background: rgb(255, 229, 143)">{{ detail.remark }}</a>
    </div>
    <div
      style="
        text-align: left;
        width: 600px;
        margin: 20px 0 0;
        margin-left: auto;
        margin-right: auto;
        word-break: normal;
        word-wrap: break-word;
        line-height: 24px;
      "
      v-html="content"
    ></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "mustknow",
  data() {
    return {
      id: this.$route.query.id,
      index: this.$route.query.index,
      name: this.$route.query.name,
      content: "",
      detail: [],
    };
  },
  created() {
    this.getNotice();
  },
  components: {},
  computed: {},
  methods: {
    getNotice() {
      axios
        .get(
          `http://pt.zhzymedia.cn/api/client_login/OrderDetail/v1?orderId=${this.id}`
        )
        .then((res) => {
          this.content = res.data.data.content;
          this.detail = res.data.data;
        });
    },
  },
};
</script>

<style lang="less">
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
